// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Página pública /politica-privacidad — tokens LoginPortal */
.lp-privacy-page {
  min-height: 100vh;
  padding: 1.25rem 1rem 2rem;
  background: var(--lp-background-divs, #f3f8ff);
  color: var(--lp-text-primary, #4d4d4d);
  font-family: var(--lp-font-family, 'Lato', sans-serif);
  box-sizing: border-box;
}

.lp-privacy-article {
  width: 100%;
  max-width: 40rem;
  margin: 0 auto;
  padding: 1.25rem 1rem;
  border: 1px solid var(--lp-border-light, #cbd5e1);
  border-radius: 0.75rem;
  background: var(--lp-surface-card, #ffffff);
  box-sizing: border-box;
}

.lp-privacy-header {
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--lp-border-light, #cbd5e1);
}

.lp-privacy-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: var(--lp-fw-bold, 700);
  line-height: 1.3;
  color: var(--lp-h-titulos, #4d4d4d);
}

.lp-privacy-lead {
  margin: 0.5rem 0 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--lp-h-subtitulos, #757575);
}

.lp-privacy-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.lp-privacy-body p {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.55;
  text-align: justify;
  color: var(--lp-text-primary, #4d4d4d);
}

.lp-privacy-link {
  color: var(--lp-blue-dark, #28466d);
  font-weight: var(--lp-fw-bold, 700);
  text-decoration: underline;
  text-underline-offset: 0.15em;
  word-break: break-all;
}

.lp-privacy-link:hover,
.lp-privacy-link:focus-visible {
  outline: none;
}

@media (min-width: 768px) {
  .lp-privacy-page {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 2.5rem 2rem 3rem;
  }

  .lp-privacy-article {
    max-width: 52rem;
    padding: 2rem 2.25rem;
  }

  .lp-privacy-title {
    font-size: 1.5rem;
  }

  .lp-privacy-lead {
    font-size: 0.9375rem;
    max-width: 36rem;
  }

  .lp-privacy-body p {
    font-size: 0.9375rem;
    max-width: 42rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PoliticaPrivacidadPage.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,8CAA8C;EAC9C,sCAAsC;EACtC,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iDAAiD;EACjD,sBAAsB;EACtB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF","sourcesContent":["/* Página pública /politica-privacidad — tokens LoginPortal */\n.lp-privacy-page {\n  min-height: 100vh;\n  padding: 1.25rem 1rem 2rem;\n  background: var(--lp-background-divs, #f3f8ff);\n  color: var(--lp-text-primary, #4d4d4d);\n  font-family: var(--lp-font-family, 'Lato', sans-serif);\n  box-sizing: border-box;\n}\n\n.lp-privacy-article {\n  width: 100%;\n  max-width: 40rem;\n  margin: 0 auto;\n  padding: 1.25rem 1rem;\n  border: 1px solid var(--lp-border-light, #cbd5e1);\n  border-radius: 0.75rem;\n  background: var(--lp-surface-card, #ffffff);\n  box-sizing: border-box;\n}\n\n.lp-privacy-header {\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--lp-border-light, #cbd5e1);\n}\n\n.lp-privacy-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: var(--lp-fw-bold, 700);\n  line-height: 1.3;\n  color: var(--lp-h-titulos, #4d4d4d);\n}\n\n.lp-privacy-lead {\n  margin: 0.5rem 0 0;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: var(--lp-h-subtitulos, #757575);\n}\n\n.lp-privacy-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.lp-privacy-body p {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.55;\n  text-align: justify;\n  color: var(--lp-text-primary, #4d4d4d);\n}\n\n.lp-privacy-link {\n  color: var(--lp-blue-dark, #28466d);\n  font-weight: var(--lp-fw-bold, 700);\n  text-decoration: underline;\n  text-underline-offset: 0.15em;\n  word-break: break-all;\n}\n\n.lp-privacy-link:hover,\n.lp-privacy-link:focus-visible {\n  outline: none;\n}\n\n@media (min-width: 768px) {\n  .lp-privacy-page {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 2.5rem 2rem 3rem;\n  }\n\n  .lp-privacy-article {\n    max-width: 52rem;\n    padding: 2rem 2.25rem;\n  }\n\n  .lp-privacy-title {\n    font-size: 1.5rem;\n  }\n\n  .lp-privacy-lead {\n    font-size: 0.9375rem;\n    max-width: 36rem;\n  }\n\n  .lp-privacy-body p {\n    font-size: 0.9375rem;\n    max-width: 42rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
